import { render, staticRenderFns } from "./Coin.vue?vue&type=template&id=7ebf8dee&scoped=true&"
import script from "./Coin.vue?vue&type=script&lang=ts&"
export * from "./Coin.vue?vue&type=script&lang=ts&"
import style0 from "./Coin.vue?vue&type=style&index=0&id=7ebf8dee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebf8dee",
  null
  
)

export default component.exports